var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopbarPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 226,
    viewBox: "0 0 353 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.52 1L273.718 1C294.349 1 311.098 17.9286 311.098 38.781C311.098 59.6335 294.349 76.5621 273.718 76.5621L254.52 76.5621L254.52 1V1Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.477 76.5625L254.512 76.5625L254.512 1.0004L314.477 1.00041C335.201 1.00041 352 17.915 352 38.7815C352 59.648 335.201 76.5625 314.477 76.5625V76.5625Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.79 76.5625L155.29 76.5625L155.29 1.0004L215.79 1.00041C236.699 1.00041 253.648 17.915 253.648 38.7815C253.648 59.648 236.699 76.5625 215.79 76.5625V76.5625Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.176 76.5474L277.176 76.4374L277.241 76.4374C317.227 76.4374 349.691 109.5 349.691 150.224L349.691 150.334L349.626 150.334C309.64 150.334 277.176 117.271 277.176 76.5474V76.5474Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.352 152.643H350.463V152.707C350.463 192.607 317.328 225 276.515 225H276.404V224.935C276.404 185.036 309.539 152.643 350.352 152.643V152.643Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39.0778L1 39.039C1 18.0445 18.6269 1.00142 40.3358 1.00142L78.9156 1.00142L78.9156 38.453C78.9156 59.4169 61.3141 76.4375 39.6347 76.4375C18.3122 76.4375 1 59.6966 1 39.0778Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2344 1.11374L81.2344 1.00142L81.3006 1.00142C122.138 1.00142 155.293 34.7527 155.293 76.3252L155.293 76.4375L155.227 76.4375C114.389 76.4375 81.2344 42.6862 81.2344 1.11374V1.11374Z",
    stroke: "#73DC78",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbarPattern);
export default __webpack_public_path__ + "static/media/topbar_pattern.923d979b23e1d4d8d66e28746dfd9cb5.svg";
export { ForwardRef as ReactComponent };